import { Button, Card, Stack, styled } from '@mui/material';

// ------------------------------------------------------------

export const StyledContainer = styled(Card)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  alignContent: 'center',
  justifyContent: 'center',
  textAlign: 'justify',
  margin: 'auto',
  width: 'auto',
  height: 'auto',

  '@media (max-width: 750px)': {
    width: '100%',
    flexDirection: 'column',
    alignitems: 'center',
    justifyContent: 'center',
    gap: 20,
  },
}));

export const StyledImage = styled('img')(() => ({
  width: '800px',

  '@media (max-width: 750px)': {
    width: '100%',
  },
}));

export const StyledTextContainer = styled(Stack)(() => ({
  width: '600px',
  height: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  margin: '30px',

  '@media (max-width: 750px)': {
    flexDirection: 'column',
    alignitems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    justifyContent: 'center',
    padding: '0px 20px',
  },
}));

export const StyledButtonContainer = styled(Stack)(() => ({
  '@media (max-width: 750px)': {
    display: 'flex',
    justifyContent: 'center',
    margin: '0px',
  },
}));

export const StyledButton = styled(Button)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: '20px',

  '@media (max-width: 750px)': {
    width: '100%',
  },
}));
